module.exports = __webpack_public_path__ + "static/media/main.4c92b5a8.png";